import { get, set, remove } from './storage.service';

/******************* CHECK *************************************
See if there is a Mindset saved and if there is show the load button */
export async function checkMindmap(){
    let data = "none";
    await get('mindmap'
    ).then(function (finalResult){
            const mindD = JSON.parse(finalResult);
            if(mindD.level !== "" || mindD.level === null){
                data = "found";
            }else{
                data = "none";
            }
            //DEBUG - console.log(finalResult);
        }).catch(err => {
            console.log("e: " + err.message);
            data = "none";
        }
    );
console.log(data);
    return data;
}
/******************* SAVE *************************************
Saves the data to the local device - whether they are done or not
or for use in case they don't have internet at the time */

export async function saveMindmap(
    savemapquestion:any,
    savecuriosity:any,
    saveresponsibilityexplore:any,
    saveempowermentobstacles:any,
    saveempowermentovercome:any,
    saveobservationdata:any,
    savecommunicationcollection:any,
    savecollaboration:any,
    //saveplanningorganizingsteps:any,
    saveproblemsolvingcreativity:any,
    savefirstname:any,
    //savelastname:any,
    savemindmaptitle:any,
    saveschoolname:any,
): Promise<void>{
    set ("mindmap",JSON.stringify({ 
        "mapquestion":savemapquestion, 
        "curiosity":savecuriosity,
        "responsibility": saveresponsibilityexplore,
        "empowerment": saveempowermentobstacles, 
        "empowerment2": saveempowermentovercome,
        "observation": saveobservationdata,
        "communication": savecommunicationcollection,
        "collaboration" : savecollaboration,
       // "planningorganizing": saveplanningorganizingsteps,
        "problemsolvingcreativity": saveproblemsolvingcreativity,
        "firstname":savefirstname,
        //"lastname": savelastname,
        "mindmaptitle":savemindmaptitle,
        "school": saveschoolname
    })
    ).then(function (finalResult) {
        console.log("saved mindset");
        console.log(finalResult);
        return true;
    }).catch(err => {
        console.log("e: " + err.message);
        return false;
    }
    );
}
/******************* LOAD *************************************
Load your saved mindset to take over the current form */
export async function loadMindmap(){
    //some stuff
    console.log("load mindmap");
    let data = "";
    await get('mindmap'
        ).then(function (finalResult){
            const mindD = finalResult;
            data = mindD; //DEBUG - console.log(mindD.level);
        }).catch(err => { //DEBUG - console.log("e: " + err.message);
            data = err.message;
        }
    );
    return data;
}
/******************* REMOVE *************************************
If the form is sent to the server remove the local version of it. */
export async function removeMindmap(): Promise<void> {
    remove('mindmap'
    ).then(function (finalResult){
        console.log('remove');
    }).catch(err => {
        //console.log("e: " + err.message);
    }
    );
}